import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'
import { getWapi } from '../helpers/initWapi'

/**
 * Web component required to use inside the Kambi client
 * https://developer.mozilla.org/en-US/docs/Web/Web_Components
 */
export class NavigationSection extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `
      <section id="NavigationSectionWidget" class="web-component">
        <h3 class="web-component__title">Other</h3>
        <ul class="web-component__unordered">
            <li class="web-component__list-item">
                <a class="web-component__link" href="/totesports" title="Tipping">
                    Tipping
                </a>
            </li>
        </ul>
      </section>
    `

    this.querySelector('a[title="Tipping"]')?.addEventListener('click', this.handleTippingClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleTippingClick)
  }

  handleTippingClick(e: Event) {
    e.preventDefault()
    getWapi().then(wapi => {
      wapi.set(wapi.TOGGLE_LEFT_NAVIGATION_OVERLAY)
      setTimeout(() => appHistory.push(AppRoutes.Tipping), 50)
    })
  }
}
